import React from 'react';

function AboutUs() {
  return (
    <div className="about-us-container">
      <p className="about-text">
        Welcome to Paradise Nursery, where green dreams come to life! We are passionate about plants
        and dedicated to bringing the beauty of nature into your home. Our wide selection of
        houseplants includes everything from lush tropical varieties to hardy succulents, ensuring
        that there is something for every plant lover.
      </p>
      <p className="about-text">
        At Paradise Nursery, our mission is to make plant ownership accessible and enjoyable for
        everyone. Whether you are a seasoned gardener or just starting your green journey, our
        team of experts is here to help. We offer a curated selection of high-quality plants,
        delivered fresh to your door with care and expertise.
      </p>
    </div>
  );
}

export default AboutUs;
